import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { PERMISSIONS_CODES } from "../../../../constants";
import { RootState } from "../../../../globals";

/*
	Una sola puerta para cobrar (Esteban, 2026-11-02). «Emitir Pago» y «Abonar» ya no tienen formulario propio: abren Registrar Pago,
	que revisa el comprobante (lectura, huella, OXXO), la referencia, las promociones y el recargo a tiempo. El servidor ya no acepta
	pagos por la vía vieja (CobrosService::SOLO_REGISTRAR_PAGO).
	Lo único que se queda aquí es «Aplicar crédito a favor» (no entra dinero nuevo): si el alumno tiene saldo a favor que alcance, se
	pregunta primero; si no, se va directo a Registrar Pago.
*/

export interface CobrarEnRegistrarProps {
	student: any;
	invoice: any;
	totalToPaid: number;
	isPartialPayment: boolean;
	isNewInvoice: boolean;
	cancel: () => void;
	showApplyCreditModal: () => void;
	openRegister: () => void;
}

const CobrarEnRegistrar: React.FC<CobrarEnRegistrarProps> = ({ student, invoice, totalToPaid, isPartialPayment, isNewInvoice, cancel, showApplyCreditModal, openRegister }) => {
	const permissions: any[] = useSelector((state: RootState) => state.rootReducer.sessionState.permissions);
	const saldo = Number(student?.generalBalance?.positiveBalance?.value || 0);
	// Las mismas reglas del modal viejo: pago completo → el saldo cubre el total; abono → basta con tener saldo.
	const abono = isPartialPayment && !isNewInvoice;
	const total = abono ? Number(invoice?.pendingAmount || 0) : Number(totalToPaid || 0);
	const conSaldo = permissions.includes(PERMISSIONS_CODES.CREDITS_PERMISSIONS.CREATE) && saldo > 0 && (isPartialPayment || saldo >= total);

	useEffect(() => {
		if (!conSaldo) {
			openRegister();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	if (!conSaldo) {
		return <React.Fragment />;
	}
	return (
		<div style={{ padding: "8px 4px 4px", display: "flex", flexDirection: "column", alignItems: "center", gap: 12 }}>
			<h5 style={{ margin: 0 }}>¿Cómo Paga?</h5>
			<p style={{ margin: 0, textAlign: "center", color: "var(--wa-apagado)" }}>
				{(student?.firstName || "El alumno") + " tiene saldo a favor de " + saldo.toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + "."}
			</p>
			<button type="button" className="btn btn-danger rounded-pill" style={{ width: "70%" }} onClick={openRegister}>Registrar Pago</button>
			<button type="button" className="btn btn-outline-danger rounded-pill" style={{ width: "70%" }} onClick={showApplyCreditModal}>Usar Saldo a Favor</button>
			<button type="button" className="btn btn-link btn-sm" onClick={cancel}>Regresar</button>
		</div>
	);
};

export default CobrarEnRegistrar;
